const UserSelectStyleNodeId = 'user-select--styles';
const UserSelectClassName = 'user-select---locked';
const getUserSelectStyle = (name) => `
.${name} * {
    user-select: none!important;
    -webkit-user-select: none!important;
    -webkit-touch-callout: none!important;
    -khtml-user-select: none!important;
    -moz-user-select: none!important;
    -ms-user-select: none!important;
}`;
function addUserSelectStyleTag() {
    if (document.getElementById(UserSelectStyleNodeId)) {
        return;
    }
    const styleNode = document.createElement('style');
    styleNode.setAttribute('id', UserSelectStyleNodeId);
    styleNode.innerHTML = getUserSelectStyle(UserSelectClassName);
    document.body.append(styleNode);
}
export function addUserSelectClass() {
    addUserSelectStyleTag();
    if (!isUserSelectPresent()) {
        document.body.classList.add(UserSelectClassName);
    }
}
export function removeUserSelectClass() {
    if (isUserSelectPresent()) {
        document.body.classList.remove(UserSelectClassName);
    }
}
export function isUserSelectPresent() {
    return document.body.classList.contains(UserSelectClassName);
}
